var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.826 30h2.178l-5.767-9.075h3.771v-1.593h-4.784l-2.026-3.187h6.81v-1.593h-6.773L25.37 2h-2.084l-7.693 11.792L8.058 2h-2.22l8.026 12.552H7.066v1.593h6.868l-2.054 3.187H7.066v1.593h3.786L5 30h2.162l5.914-9.075H18L23.825 30zm-6.85-10.668-1.42-2.212-1.441 2.212h2.86z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXno);
export default __webpack_public_path__ + "static/media/XNO.6c76e5567ebd99e8ff64a425cf6d5d02.svg";
export { ForwardRef as ReactComponent };